module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("MOUNT DESERT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mount Desert. When you hear the name spoken, what does it call up in your mind? Just what it should: a picture of Champlain sailing the harbor in the dim and misty past and first catching sight of a barren chain of mountains rising from the bosom of a rocky island. He named it the “Ile of the Desert Mountains” or “Mount Desert.” Surely it is a fitting and proper name for our island home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is an unexplained peace and quiet on Mount Desert. People come here and return year after year.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('i', [_vm._v("The whole island has a romantic history and dreams of bygone years still cling to the hills and meadows. Where could be found more beauty, more charm, more mystery, than on the Island of Mount Desert?")])]), _vm._v(" "), _c('p', {
    staticClass: "ext3"
  }, [_c('i', [_vm._v("—Jane Wheeler Parker, Bar Harbor High School class of 1916")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('i', [_vm._v("You may live in Bar Harbor, but I still live in Eden.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext3"
  }, [_c('i', [_vm._v("—Melinda Brewer after the name of town was changed from Eden to Bar Harbor, 1918")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('i', [_vm._v("As Bar Harbor receded in the distance it looked like a dream island rising from the sea, the same pale blue as Capri seen from Naples but a far more beautiful shape! There’s nothing to compare with it!")])]), _vm._v(" "), _c('p', {
    staticClass: "ext3"
  }, [_c('i', [_vm._v("—journals of Marian Lawrence Peabody, courtesy of Gertrude Lawrence McCue, Bar Harbor Historical Society")])]), _vm._v(" "), _c('div', {
    staticClass: "image-break"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/22-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Map of the Bar Harbor Historic Buildings and Monuments Trail. "), _c('i', [_vm._v("Courtesy of the author.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e01af768","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mountdesert.vue
// module id = 78
// module chunks = 0